export const NOTICE_LIST_REQUEST = 'NOTICE_LIST_REQUEST';
export const NOTICE_CREATE_REQUEST = 'NOTICE_CREATE_REQUEST';
export const NOTICE_UPDATE_REQUEST = 'NOTICE_UPDATE_REQUEST';
export const NOTICE_DELETE_REQUEST = 'NOTICE_DELETE_REQUEST';
export const NOTICE_SORT_UPDATE_REQUEST = 'NOTICE_SORT_UPDATE_REQUEST';